(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["natural-finish-variant-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('natural-finish-variant-carousel')) {
    customElements.define(
      'natural-finish-variant-carousel',
      class NaturalFinishVariantCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-carousel-track]');
          this.previousButton = this.querySelector('[data-carousel-previous]');
          this.nextButton = this.querySelector('[data-carousel-next]');

          if (!this.track || !this.previousButton || !this.nextButton) return;

          this.desktopCount = Number.parseInt(this.dataset.desktopCount, 10) || 4;
          this.mobileCount = Number.parseInt(this.dataset.mobileCount, 10) || 1;
          this.gap = Number.parseFloat(this.dataset.gap) || 0;
          this.peek = Number.parseFloat(this.dataset.peek) || 0;
          this.previousButton.addEventListener('click', () => this.move(-1));
          this.nextButton.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });

          this.resizeObserver = new ResizeObserver(() => {
            this.sizeCards();
            this.updateControls();
          });
          this.resizeObserver.observe(this.track);
          this.sizeCards();
          this.updateControls();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        sizeCards() {
          const isDesktop = window.matchMedia('(min-width: 750px)').matches;
          this.cardsPerPage = isDesktop ? this.desktopCount : this.mobileCount;
          const reservedSpace = this.peek + this.cardsPerPage * this.gap;
          const cardWidth = Math.max(80, (this.track.clientWidth - reservedSpace) / this.cardsPerPage);

          this.style.setProperty('--nfvc-card-width', `${cardWidth}px`);
        }

        move(direction) {
          const firstCard = this.track.querySelector('.nfvc__card');
          if (!firstCard) return;

          const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = (firstCard.getBoundingClientRect().width + gap) * this.cardsPerPage;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

          this.track.scrollBy({ left: distance * direction, behavior });
        }

        requestUpdate() {
          if (this.updateFrame) return;

          this.updateFrame = requestAnimationFrame(() => {
            this.updateControls();
            this.updateFrame = null;
          });
        }

        updateControls() {
          const maximumScroll = this.track.scrollWidth - this.track.clientWidth;
          this.previousButton.disabled = this.track.scrollLeft <= 1;
          this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
